<template lang="pug">
  div
    app-modal-visualiza-pdf(
      v-if="showModalVisualizaPdf",
      @closeModal="closeModalVisualizaPdf",
      :titulo="tituloModal",
      :tipo="tipoModal",
      :isImagem="isImagem"
      :conteudo="conteudoModal",
      :conteudoSemId="conteudoModalSemid"
      :isVTN="false"
    )
    app-divider(:label="titulo", :tooltip="informacao", v-if="showDivider")
    el-row
      app-upload-documentos(
        :id="idUploadDocumento"
        v-model="documentoSelecionado"
        :target="urlUpload"
        :fileType="validExtensions"
        :tiposDocumentos="documentosFiltrados"
        :pecasTecnicas="pecasTecnicas"
        :maxSize="maxSize",
        :aba="aba",
        :required="tiposDocumentosObrigatorios && tiposDocumentosObrigatorios.length > 0 && isRequired",
        :documentos="documentos",
        :mensagemErroFilaPlantaMemorial="mensagemErroFilaPlantaMemorial",
        :isValidacaoPeloMenosUmDocumento="isValidacaoPeloMenosUmDocumento",
        @mudaTipo="mudaTipo",
        @anexar="anexar",
        @setDadosPlanilha="setDadosPlanilha"
        :mensagemOutros="mensagemOutros"
      )

    el-row
      validation-provider(:rules="requireDocumentosObrigatorios()" v-slot="{ errors }", :name="aba + '/Documentos'")
        .input(:class="{'erro box-error' : errors.length}")
          el-table(
            :data='documentos',
            v-model="validationValues"
          )
            div(slot='empty')
              span Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".
            el-table-column(
              prop='tipoDocumento.descricao',
              label='Tipo de documento:'
              align="left",
            )
            el-table-column(
              prop='fileName',
              label='Anexos'
            )
            el-table-column(
              label='Ações',
              align="center",
              :width="isEstadoBA ? '100' : '80'"
            )
              template(slot-scope='scope')
                app-action-button(
                  v-if="isEstadoMA || isEstadoBA"
                  :disabled="!isDocumentoParaVisualizacao(scope.row)"
                  :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                  icone="eye",
                  :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                  fontSize="18",
                  @click="abrirDocumento(scope.row)"
                )
                app-action-button(
                  v-if="showDownloadDocumentos && scope.row.id"
                  icone="download",
                  @click="getDownload(scope.row)",
                  cor="#666666",
                  text="Baixar Documento"
                )
                app-action-button(
                  icone="times",
                  @click="deleteRow(scope.row, scope.$index)",
                  cor="#CF0021",
                  text="Remover documento"
                )
        span.help.erro {{ errors[0] }}

</template>

<script>
import FileSaver from 'file-saver'
import AppActionButton from '@/components/AppActionButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import axios from '@/utils/api'
import AppLabel from '@/components/AppLabel'
import AppUploadDocumentos from './AppUploadDocumentos'
import _ from 'lodash'
import utils from '@/utils/utils'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'

const {visualizarDocumentosPDF, showAcaoDowloadDocumentos} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppActionButton,
    AppUploadDocumentos,
    AppDivider,
    AppLabel,
    AppModalVisualizaPdf
  },

  data () {
    return {
      keyT: 0,
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      documentoSelecionado: null,
      isEstadoMA: process.env.ESTADO === 'ma',
      isEstadoBA: process.env.ESTADO === 'ba',
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  props: {
    isAnalise: {
      type: Boolean,
      required: false
    },
    titulo: {
      type: String,
      required: false,
      default: 'Documentação'
    },
    aba: {
      type: String,
      required: true
    },

    //! sempre necessário quando houver validação
    observer: {
      type: Object
    },

    documentos: {
      type: Array
    },

    tiposDocumentos: {
      type: Array,
      required: true
    },

    tiposDocumentosObrigatorios: {
      type: Array,
      required: false
    },

    validExtensions: {
      type: Array,
      required: true
    },

    maxSize: {
      type: Number,
      required: true
    },

    pecasTecnicas: {
      type: Boolean,
      default: false
    },

    pecasTecnicasSalvas: {
      type: Array
    },

    idUploadDocumento: {
      type: String,
      default: 'appUploadDocumento'
    },

    removeOutros: {
      type: Boolean,
      default: false
    },

    validateRule: {
      type: String,
      default: null
    },

    mensagemErroFilaPlantaMemorial: {
      type: String,
      default: ''
    },

    isOutraPessoa: {
      type: Boolean,
      required: false,
      default: false
    },

    isDocumentoImagex: {
      type: Boolean,
      required: false,
      default: false
    },

    idLaudoDiagnostico: {
      type: Number
    },

    isRequired: {
      type: Boolean,
      required: false,
      default: true
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    mensagemOutros: {
      type: String,
      required: false
    },
    isValidacaoPeloMenosUmDocumento: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {

    informacao () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return 'Para esta análise nenhum documento é obrigatório,<br> mas é necessário anexar pelo menos um deles.'
      }

      if (this.tiposDocumentosObrigatorios && this.tiposDocumentosObrigatorios.length > 0) {
        const tiposObrigatorios = this.verificarObrigatoriedadeOutros.map(tipoDocumentoObrigatorio => tipoDocumentoObrigatorio.descricao)

        let infoTipoDocumentosObrigatorios = 'Documentos obrigatórios:'

        tiposObrigatorios.forEach(documento => { // eslint-disable-line
          infoTipoDocumentosObrigatorios += '<br> - '
          infoTipoDocumentosObrigatorios += documento
        })

        return infoTipoDocumentosObrigatorios
      }
      return ''
    },

    showDownloadDocumentos () {
      return showAcaoDowloadDocumentos()
    },

    validationValues () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return { documentos: this.documentos, tiposDocumentos: this.tiposDocumentos }
      }
      return { documentos: this.documentos, documentosObrigatorios: this.documentosObrigatoriosFiltrados, isOutraPessoa: this.isOutraPessoa }
    },

    documentosFiltrados () {
      return _.uniqBy(this.tiposDocumentos, 'codigo')
    },

    documentosObrigatoriosFiltrados () {
      return _.uniqBy(this.verificarObrigatoriedadeOutros, 'codigo')
    },

    verificarObrigatoriedadeOutros () {
      return this.removeOutros ? this.tiposDocumentosObrigatorios.filter(t => t.tipo !== 'OUTROS' && t.tipo !== 'OUTROS_GEOMENSOR' && t.tipo !== 'OUTROS_FISCALIZADOR' && t.tipo !== 'OUTROS_VISTORIADOR' && t.tipo !== 'OUTROS_BENEFICIARIO' && t.tipo !== 'OUTROS_ADMINISTRATIVO') : this.tiposDocumentosObrigatorios
    }

  },

  methods: {
    ...mapActions({
      getDowloadDocument: 'download/downloadDocument'
    }),
    mudaTipo (opcao) {
      this.$emit('mudaTipo', opcao)
    },
    async getDownload (documento) {
      const file = await this.getDowloadDocument(documento)
      FileSaver.saveAs(file, documento.fileName)
    },
    anexar (documento, invalidos) {
      if ((documento.tipoDocumento.codigo === 'TABELA_DADOS_CARTOGRAFICOS' && this.documentos.find(doc => doc.tipoDocumento.codigo === 'TABELA_DADOS_CARTOGRAFICOS')) ||
        (documento.tipoDocumento.codigo === 'VALIDACAO' && this.documentos.find(doc => doc.tipoDocumento.codigo === 'VALIDACAO')) || (this.isDocumentoImagex && this.documentos.find(doc => doc.tipoDocumento.codigo === documento.tipoDocumento.codigo))) {
        invalidos.push(`Você já anexou um(a) ${documento.tipoDocumento.descricao}`)
      } else {
        if (this.idLaudoDiagnostico) {
          documento.id = null
          this.documentos.push(documento)
        } else {
          this.documentos.push(documento)
        }
        this.$emit('addedDoc', documento)
      }
    },

    deleteRow (row, index) {
      if (this.isAnalise) {
        this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
          () => {
            if (row.id && (typeof row.id) !== 'string') {
              axios({
                method: 'DELETE',
                url: `documento/delete`,
                data: row,
                responseType: 'blob'
              }).then(() => {
                this.documentos.splice(index, 1)
              }).catch(() => {
                this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.')
              })
            } else {
              this.documentos.splice(index, 1)
            }
          },
          () => { })
      } else if (this.idLaudoDiagnostico) {
        this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
          () => {
            if (row.id) {
              axios({
                method: 'DELETE',
                url: `laudo/deleteDocumentoDiagnostico`,
                data: { idDocumento: row.id, idLaudo: this.idLaudoDiagnostico },
                responseType: 'blob'
              }).then(() => {
                this.documentos.splice(index, 1)
              }).catch(() => {
                this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.')
              })
            } else {
              this.documentos.splice(index, 1)
            }
          },
          () => { })
      } else {
        this.documentos.splice(index, 1)
        this.$emit('removedDoc', row)
      }
    },

    requireDocumentosObrigatorios () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return 'peloMenosUmDocumentoObrigatorio'
      }
      const validateRule = this.validateRule ? this.validateRule : 'documentosObrigatorios'
      return this.tiposDocumentosObrigatorios && this.isRequired ? validateRule : ''
    },

    setDadosPlanilha (valor) {
      this.$emit('setDadosPlanilha', valor)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tituloModal = 'Visualizar Documento'
      this.tipoModal = 'DOCUMENTO_SEM_ID'
      this.conteudoModal = 0
      this.isImagem = this.isExtensaoImagem(documento)
      this.conteudoModalSemid = {...documento, key: documento.fileKey, id: null}
      this.showModalVisualizaPdf = true
      this.tituloDocumento = documento.tipoDocumento.descricao
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  },

  // Garante que a validação ocorra quando o componente fica inativo, devido ao keep-alive. (Equivalente ao beforeDestroy)
  async deactivated () {
    if (this.observer) {
      await this.observer.validate({
        skipIfEmpty: false,
        providerName: this.aba + '/Documentos'
      })
    }
  },

  watch: {
    documentos: {
      handler (val) {
        if (this.observer) {
          this.observer.validate({
            skipIfEmpty: false,
            providerName: this.aba + '/Documentos'
          })
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">

  .table {
    width: 100%;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  .label-info{
    margin-bottom: 20px;
    span {
      font-size: 12px;
    }
  }

  .el-alert {
    color: #047fa2 !important;
  }

</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppDocumentos.vue